import { render } from "./list-rsos.vue?vue&type=template&id=f19ade32"
import script from "./list-rsos.vue?vue&type=script&lang=js"
export * from "./list-rsos.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__